import factory from '@helpers/storeFactories/factory';
import { apiService } from '@api';
import storeConstants from '@/utils/constants/store';

const STORE_NAME = 'currenciesLookup';

const store = factory.createStore(
    STORE_NAME,
    {
        get: apiService.currencies.get,
    },
    {
        actionsOptions: {
            get: {
                refresh: false,
                offset: 0,
                limit: 99,
            },
            controlItems: storeConstants.ACTION_GET_CONTROL_ITEMS.ALL,
        },
    }
);

export default store;
